<div *ngIf="menu.active.sub === 'activity'">
    <div class="wrap uk-margin-bottom">

        <div uk-grid class="uk-margin-bottom remove-grid-ml-pl">
            <div class="uk-width-expand">
                <span class="main-title"><span class="bold">Alertes</span> pour le <span humanDateFormat="{{ today }}"
                        shortened="true"></span></span>
            </div>
            <div class="uk-width-3-12 uk-text-right">
                <div class="back-button" style="margin-top: 4px;" [routerLink]="['/reservation/sinister/list']">
                    <span>Voir toutes les alertes</span>
                    <img src="../../../assets/icons/ArrowRight.svg" width="32px" height="32px" alt="arrowright">
                </div>
            </div>
        </div>

        <div class="uk-grid uk-grid-small">
            <div class="uk-width-12-12 bold" style="padding: 35px 0px 35px 0px; margin-left: 15px;"
                *ngIf="noResult === true">
                Vous n'avez pas eu d'alertes ces 30 derniers jours.
            </div>
            <div class="uk-width-12-12 uk-text-center" style="padding: 35px 0px 35px 0px; margin-left: 15px;"
                *ngIf="loadingStatus === true">
                <div uk-spinner></div>
            </div>
            <a *ngFor=" let sinister of sinisters; let i=index" class="uk-width-4-12 uk-margin-top uk-margin-bottom">
                <div class="uk-card card hover card-border station-card pointer remove-grid-ml-pl alert-card" uk-grid
                    style="margin-left: 0px;" [routerLink]="['/reservation/informations/' + sinister.idBooking ]">
                    <div class="uk-width-2-12">
                        <img class="img-red" src="../../../assets/icons/Warning.svg" width="100%" alt="warning">
                    </div>
                    <div class="uk-width-10-12" style="line-height: 1.18; margin-top: 5px;">
                        <div class="uk-display-block margin-left-mini color-grey" style="font-size: 16px;">
                            <span class="bold uk-text-uppercase">état des lieux</span>
                            <span class="light uk-text-uppercase margin-left-mini">{{ sinister.vehicle.name }}</span>
                        </div>
                        <div class="uk-display-block margin-left-mini" style="font-size: 15px;">
                            <span class="regular color-dark-gray">Déclaré le <span
                                    humanDateFormat="{{ sinister.ISOCreated }}" noDay="true"></span></span>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>




    
    <app-reservation-planner
        [idSocietyVop]="plannerSocietyId"
        [idAccountTarget]="plannerAccountTarget"
        [mode]="plannerMode"
        [showCreateButton]="true"
        [createModeLabel]="plannerCreateModeLabel"
        (addEventClick)="openFindUserModal()"
        (deactivateCreate)="onPlannerCancelled()"
        (reservationCreated)="onReservationCreated($event)"
        (cancelled)="onPlannerCancelled()">
    </app-reservation-planner>
  

    <app-find-user
        [showSocietyPicker]="isSuperAdmin"
        (changed)="onFindUserConfirmed($event)">
    </app-find-user>
</div>

<div *ngIf="menu.active.sub === 'map'">
    <app-dashboard-map></app-dashboard-map>
</div>


<div *ngIf="menu.active.sub === 'message'">
    <app-client-support></app-client-support>
</div>
